module.exports = __webpack_public_path__ + "static/media/91916784.fe0a0c94.png";